import { InfoItem, InfoLabel, InfoValue } from '../../styled-components'

const DetailsInfoItem = ({ label, value }) => {
  return (
    <InfoItem>
      <InfoLabel>{label}</InfoLabel>
      <InfoValue>{value}</InfoValue>
    </InfoItem>
  )
}

export default DetailsInfoItem
